import React, { useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { Button } from "Components/Button";
import CheckboxGroup from "Components/Checkbox/CheckboxGroup";
import KeyboardHint from "Components/KeyboardHint";
import ErrorMessage from "Components/ErrorMessage";
import InfoContentMotionWrapper from "Components/MotionWrapper/InfoContentMotionWrapper";
import { topGoalsData } from "Data";
import styles from "Styles/CompanySize.module.css";
import inputStyles from "Styles/Inputs.module.css";

const TopGoalsFormContent = ({ submitCB = () => {}, defaultGoals = [] }) => {
  const [checkedValues, setCheckedValues] = useState(defaultGoals);

  useEffect(() => {
    if (defaultGoals && defaultGoals.length > 0) {
      setCheckedValues(defaultGoals);
    }
  }, [defaultGoals]);

  const methods = useForm();

  const checkboxData = topGoalsData.map((item) => ({
    label: item.label,
    value: item.value,
    checked: checkedValues.includes(item.value),
  }));

  const handleCheck = (e) => {
    const value = e.target.value;
    if (e.target.checked) {
      if (checkedValues.length < 3) {
        setCheckedValues((prev) => [...prev, value]);
      }
    } else {
      setCheckedValues((prev) => prev.filter((item) => item !== value));
    }
  };

  const fieldSubmitCB = (data, e) => {
    e.preventDefault();
    submitCB(checkedValues);
  };

  const isMaxSelected = checkedValues.length >= 3;

  return (
    <InfoContentMotionWrapper>
      <div className={styles.content}>
        <fieldset className={inputStyles.fieldset}>
          <legend className={inputStyles.legend}>至少選擇一個，最多三個</legend>
          <FormProvider {...methods}>
            <form
              className={inputStyles.form}
              onSubmit={methods.handleSubmit(fieldSubmitCB)}
            >
              <CheckboxGroup
                checkboxData={checkboxData.map((item) => ({
                  ...item,
                  disabled:
                    isMaxSelected && !checkedValues.includes(item.value),
                }))}
                handleCheck={handleCheck}
                useValue={true}
              />

              {methods.formState.errors?.checkbox && (
                <ErrorMessage text="請選擇 1 至 3 項" />
              )}

              <div
                style={{ display: "flex", alignItems: "end", gap: "0.75rem" }}
              >
                <Button
                  disabled={checkedValues.length < 1}
                  marginTop
                  type="action"
                  submit
                >
                  OK
                </Button>
                <KeyboardHint />
              </div>
            </form>
          </FormProvider>
        </fieldset>
      </div>
    </InfoContentMotionWrapper>
  );
};

export default TopGoalsFormContent;
